import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home\"><defs><style type=\"text/css\"></style></defs><path d=\"M596.222351 18.110365l287.909028 205.393311c61.737458 29.012765 100.776693 88.488934 100.776693 153.468995v420.258437C984.908072 898.946449 897.272455 981.334169 789.327902 981.334169H240.047992c-108.029884 0-195.58017-82.38772-195.580169-184.060396V376.972671c0-64.980061 39.039235-124.413564 100.776693-153.468995L433.153544 18.110365a192.593562 192.593562 0 0 1 163.068807 0z m143.357192 595.23101H289.796351a40.873866 40.873866 0 1 0 0 81.790399h449.783192a40.873866 40.873866 0 0 0 0-81.790399z\" p-id=\"5373\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home.svg
// module id = U9Ws
// module chunks = 19